import type { GeoLocation } from '@bambi/api-client/schemas';
import { Button } from '@bambi/component-library/src/components/Button/Button';
import { PencilIcon } from '@heroicons/react/24/outline';
import { useCallback } from 'react';

import {
  setSelectedGeolocation,
  setShowGeolocationModal,
} from '../../setting.slice';
import { useAppDispatch } from 'src/app/store/hooks';

interface RowActionsProps {
  geolocation: GeoLocation;
}

export function RowActions({ geolocation }: RowActionsProps) {
  const dispatch = useAppDispatch();

  const onEditGeolocation = useCallback(() => {
    dispatch(setSelectedGeolocation(geolocation));
    dispatch(setShowGeolocationModal(true));
  }, [dispatch, geolocation]);

  return (
    <Button
      className="group cursor-pointer"
      variant="ghost"
      onClick={onEditGeolocation}
      ariaLabel="Edit"
    >
      <PencilIcon className="w-[24px] group-hover:text-mint" />
    </Button>
  );
}
